import React from "react";
import "./BaseHeaderStyles.scss";
import logo from "../../assets/logo.png";
import { useSelector } from "react-redux";
import { RootState } from "../../../application/store";

const BaseHeader: React.FC = () => {
  const organizationDetails = useSelector(
    (state: RootState) => state.booking.organizationDetails
  );
  const getImage = () => {
    const { Web, Mobile } = organizationDetails.BannerImage;
    return window.screen.width < 600 ? Mobile : Web;
  };
  return (
    <div
      className='Baseheader'
      style={{ backgroundImage: `url(${getImage()})` }}
    >
      <div className='logo-container'>
        <img alt='' src={organizationDetails?.OrganizationDetails?.Logo} />
      </div>
      <div className='details'>
        <div className='header'>
          {organizationDetails?.OrganizationDetails?.Name}
        </div>
        <div className='sub-header'>
          {organizationDetails?.Address?.AddressLine01},{" "}
          {organizationDetails?.Address?.City},{" "}
          {organizationDetails?.Address?.PostalCode}
        </div>
      </div>
    </div>
  );
};
export default BaseHeader;
